import { defineMessages } from 'react-intl';

export default defineMessages({
  recipient: {
    id: 'view.quotation.recipient.label',
    defaultMessage: 'Recipient',
  },
});
